import {HTTP} from "@/plugins/axios";
import {resolveServerParams} from "@/plugins/constants";
import mixin from "@/mixins";

const depositTypes = {
    namespaced: true,
    state: {
        depositTypes: {},
        createdDepositType: {},
        getOneDepositType: {},
        updatedDepositType: {},
    },
    mutations: {
        SET_DEPOSIT_TYPES (state, value) { state.depositTypes = value },
        SET_CREATED_DEPOSIT_TYPE (state, value) {state.createdDepositType = value},
        SET_GET_ONE_DEPOSIT_TYPE (state, value) {state.getOneDepositType = value},
        SET_UPDATED_DEPOSIT_TYPE (state, value) {state.updatedDepositType = value},
    },
    actions: {
        GET_ALL({commit}, serverParams) {
            return new Promise((resolve, reject) => {
                serverParams = resolveServerParams(serverParams);
                HTTP.get(`/DepositTypes` +
                        `${serverParams._start}` +
                        `${serverParams._end}` +
                        `${serverParams._sort}` +
                        `${serverParams._order}` +
                        `${serverParams._search}` +
                        `${serverParams.custom_params}`)
                    .then((response) => {
                        commit('SET_DEPOSIT_TYPES', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        commit('SET_DEPOSIT_TYPES', {})
                        reject(error)
                    });
            })
        },
        GET_ONE({commit}, id) {
            return new Promise((resolve, reject) => {
                HTTP.get(`/DepositTypes/${id}`)
                    .then((response) => {
                        commit('SET_GET_ONE_DEPOSIT_TYPE', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        commit('SET_GET_ONE_DEPOSIT_TYPE', {})
                        reject(error)
                    });
            })
        },
        CREATE({commit}, form) {
            mixin.removeEmptyAndNull(form)
            return new Promise((resolve, reject) => {
                HTTP.post(`/DepositTypes`, form)
                    .then((response) => {
                        commit('SET_CREATED_DEPOSIT_TYPE', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        commit('SET_CREATED_DEPOSIT_TYPE', {})
                        reject(error)
                    });
            })
        },
        UPDATE({commit}, {id, form}) {
            mixin.removeEmptyAndNull(form)
            return new Promise((resolve, reject) => {
                HTTP.put(`/DepositTypes/${id}`, form)
                    .then((response) => {
                        commit('SET_UPDATED_DEPOSIT_TYPE', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        commit('SET_UPDATED_DEPOSIT_TYPE', {})
                        reject(error)
                    });
            })
        },
        DELETE(commit, ids) {
            return new Promise((resolve, reject) => {
                HTTP.delete(`/DepositTypes/${ids}`)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error)
                    });
            })
        },
    },
    getters : {
        depositTypes: state => state.depositTypes,
        createdDepositType: state => state.createdDepositType,
        getOneDepositType: state => state.getOneDepositType,
        updatedDepositType: state => state.updatedDepositType,
    }
}

export default depositTypes;
